import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Catalog Overview page */
export default class SubscriberOnBoarding extends React.Component {
  static propTypes = {
    run: PropTypes.bool.isRequired,
    setScroll: PropTypes.func.isRequired
  }

  static defaultProps = {
    includeTlm: true
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
        callback={evt => {
          if (evt.index === 2)
            this.props.setScroll()
          }
        }
        />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Catalog Overview dashboard!<br /><br />This page shows metrics for three networks selected from the drop down menus in the Network buttons.<br /></p>),
        disableBeacon: true,
        target: '#subscriberTour1'
      },
      {
        ...common,
        content: (<p>The top section compares the three networks on various metrics and provides a high level view of audience engagement.<br /><br />These metrics focus on volume and ratings.</p>),
        target: '#subscriberTour2'
      },
      {
        ...common,
        content: (<p>The bottom section focuses on one network at a time to further explore the offerings that network subscribers have access to and are engaging with.<br/><br/>Let's Go!</p>),
        target: '#subscriberTour3'
      }
    ]

    return steps
  }
}
